"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "next-themes";
import posthog from "posthog-js";
import { useEffect, useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AppConfigProvider } from "@/lib/config";
import type { AppConfig } from "@/lib/config-server";
import type { ReactNode } from "react";
interface ProvidersProps {
  children: ReactNode;
  config: AppConfig;
}
export function Providers(t0) {
  const $ = _c(14);
  const {
    children,
    config
  } = t0;
  let t1;
  let t2;
  if ($[0] !== config.posthogHost || $[1] !== config.posthogKey) {
    t1 = () => {
      if (!config.posthogKey) {
        return;
      }
      posthog.init(config.posthogKey, {
        api_host: config.posthogHost ?? "https://us.i.posthog.com",
        capture_pageview: "history_change",
        autocapture: false,
        disable_session_recording: true,
        person_profiles: "identified_only"
      });
    };
    t2 = [config.posthogKey, config.posthogHost];
    $[0] = config.posthogHost;
    $[1] = config.posthogKey;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const [queryClient] = useState(_temp);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = process.env.NODE_ENV === "development" && <ReactQueryDevtools buttonPosition="top-right" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== queryClient) {
    t4 = <QueryClientProvider client={queryClient}>{children}{t3}</QueryClientProvider>;
    $[5] = children;
    $[6] = queryClient;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Toaster />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <ThemeProvider attribute="class" defaultTheme="system" enableSystem={true} storageKey="theme">{t4}{t5}</ThemeProvider>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== config || $[12] !== t6) {
    t7 = <AppConfigProvider config={config}>{t6}</AppConfigProvider>;
    $[11] = config;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 300000,
        retry: false
      }
    }
  });
}